// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rating{display:flex}.rating .rating-star{margin-right:var(--space-2)}.rating .rating-star-filled{color:var(--accent-color)}.rating .rating-star-outlined{color:var(--grey-light)}.rating .rating-star-half{position:relative;width:16px;height:16px}.rating .rating-star-half .rating-star-outlined{direction:rtl;margin-left:8px}.rating .rating-star-half .rating-star-filled,.rating .rating-star-half .rating-star-outlined{width:8px;overflow:hidden;position:absolute;left:0;top:0}\n", ""]);
// Exports
module.exports = exports;
